import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { MessageService } from 'primeng/api';
import { label } from '../constants/labels';
import { environment } from '@env/environment';
import { BaseAPIService } from '../Services/api.base.service';
import { TelemetryService } from '../Services/telemetry.service';
import { TranslateService } from '@ngx-translate/core';


@Pipe({
  name: 'precision',
  pure: true
})

export class Precision implements PipeTransform {
  transform(value: any, args?: any): any {
    return !Number.isInteger(value) ? value.toFixed(1) : value;
  }
}

@Component({
  selector: 'app-telemetry',
  templateUrl: './telemetry.component.html',
  styleUrls: ['./telemetry.component.scss'],
  providers: [MessageService]
})

export class TelemetryComponent implements OnInit {
  active = 1;
  labels: any;
  isLoading: boolean = false;
  last_connected_on: string;
  deviceFullName: string;
  commercial_name: string;
  forExpo: boolean = environment.forExpo;
  deviceDongleUId: string;
  public isEditing: boolean;
  public pendingDeviceName: string;
  public value!: string;
  deviceId: number
  firmwareVersion: string;
  isWireless: boolean;

  constructor(private readonly baseService: BaseAPIService, private readonly telemetryService: TelemetryService, private readonly messageService: MessageService, private readonly translate: TranslateService) {
    this.isEditing = false;
    this.pendingDeviceName = "";
  }
  ngOnInit() {
    this.labels = label;
    this.isWireless = this.telemetryService.cooler_isWireless;
    this.commercial_name = this.telemetryService.controllerTypeName;
    this.deviceFullName = this.telemetryService.cooler_name;
    this.last_connected_on = this.telemetryService.cooler_lastConnectedOn;
    this.deviceDongleUId = this.telemetryService.dongleUId;
    this.deviceId = this.telemetryService.cooler_id
    this.firmwareVersion = this.telemetryService.cooler_firmwareVersion;
  }
  public edit(): void {
    this.pendingDeviceName = this.deviceFullName;
    this.isEditing = true;
  }

  public updateDeviceName(): void {
    this.isLoading = true;
    if (this.pendingDeviceName !== this.deviceFullName) {
      this.baseService.PATCH(`/Telemetry/UpdateDeviceName/${this.deviceId}?${this.encodeQuery({ newDeviceName: this.pendingDeviceName })}`, {}).subscribe((result: boolean) => {
        if (result) {
          this.deviceFullName = this.pendingDeviceName;
          this.telemetryService.cooler_name = this.pendingDeviceName;
        }
        this.isLoading = false;
        this.isEditing = false;
      },
      (error) => {
        if (error.status === 400) {
          this.messageService.add({ severity: 'error', summary: this.translate.instant('Error'), detail: this.translate.instant(error.error), key: 'error' });
        }
        this.isLoading = false;
        this.isEditing = false;
      }
    );
    } else {
      this.isLoading = false;
      this.isEditing = false;
    }
  }
  encodeQuery(data) {
    let query = '';
    for (const d in data) {
      if (data[d] !== '') {
        query += `${encodeURIComponent(d)}=${data[d] instanceof Date ? new Date(data[d]).toISOString() : encodeURIComponent(data[d])}&`;
      }
    }
    return query.slice(0, -1)
  }
}

